import React from 'react'
import './Message.css'
import ReactEmoji from 'react-emoji'
import CryptoJS from "crypto-js";





const Message = ({currentUser, name, text}) => {
 
const decrypt = (encryptedMessage) => {
        var bytes  = CryptoJS.AES.decrypt(encryptedMessage, process.env.REACT_APP_SECRETKEY);
         var decryptedData = bytes.toString(CryptoJS.enc.Utf8);
         return decryptedData
    }
 let isSentByCurrentUser = false;
 let message;
 if(currentUser.trim().toLowerCase() === name)
   isSentByCurrentUser = true;
  if(name !== "admin") {
     message = decrypt(text)
  }
  else {
      message = text
  }
  return (
   isSentByCurrentUser ? 
       <div className="messageContainer justifyEnd">
           <p className='sentText'>{name}</p>
           <div className = "messageBox backgroundLight">
               <p className = "messageText colorDark">{ReactEmoji.emojify(message)}</p>
           </div>
       </div>
    : <div className="messageContainer justifyStart">
    
    <div className = "messageBox backgroundBlue">
        <p className = "messageText ">{ReactEmoji.emojify(message)}</p>
    </div>
    <p className='sentText'>{name}</p>
</div>
  )
}

export default Message